module.exports = __webpack_public_path__ + "img/image_tank-storage-construction2_1920px.d584709a.jpg";